import {
    clearAuthHeadersFromStorage,
    getBridgeSdk,
    getDownstreamHostsValue,
    GlobalHeaderState,
    SwgyHeaderKeysList,
} from "@swiggy-private/checkout-core";
import { MARKETPLACE_BUSINESS_LINE, RawOrderData } from "@swiggy-private/payment-types";
import { isIos } from "@payment-client/helpers/Misc";
import {
    CROUTON_WEBVIEW_IOS_VERSION,
    DEFAULT_DINEOUT_ORDER_URL,
    DINEOUT_ORDER_URL,
} from "@payment-client/constants/Dineout";

export function storeOrderInfoEvent(orderData: RawOrderData, clearHeaders: boolean): void {
    if (clearHeaders) {
        clearAuthHeadersFromStorage();
    }
    const versionCode = GlobalHeaderState.getHeader(SwgyHeaderKeysList.versionCode);

    let orderInfoUrl;
    const redirectURL = getDownstreamHostsValue(DINEOUT_ORDER_URL) || DEFAULT_DINEOUT_ORDER_URL;
    if (!isIos() || Number(versionCode) >= CROUTON_WEBVIEW_IOS_VERSION) {
        orderInfoUrl = `${redirectURL}?orderId=${Number(orderData.order_id)}`;
    }

    getBridgeSdk()
        .storeOrderInfoEvent(orderData, MARKETPLACE_BUSINESS_LINE.DINEOUT, orderInfoUrl)
        .catch(() => void 0);
}
